import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { Link } from "react-router-dom";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { Sparklines, SparklinesLine, SparklinesSpots } from "react-sparklines";
import moment from "moment";

class ElectraWidget extends React.Component {
  state = {
    errors: {},
    load: false,
  };

  render() {
    const { SearchBar } = Search;
    const columns = [
      {
        dataField: "naam",
        text: "Plaats",
        formatter: (cellContent, row) => {
          if (cellContent.NL) {
            return cellContent.NL;
          } else {
            return cellContent;
          }
        },
      },
      {
        dataField: "lastcheck",
        text: "Laatste data",
        formatter: (cellContent, row) => {
          return row?.sensor?.lastcheck ? moment(row?.sensor?.lastcheck).fromNow() : "";
        },
      },
      {
        dataField: "lastcheck",
        text: "Meterstand",
        formatter: (cellContent, row) => {
          return row?.sensor?.lastvalue >= 0 ? Number(row?.sensor?.lastvalue).toFixed(2) : "";
        },
      },

      {
        text: "Instellen",
        dataField: "soort",
        headerAlign: "center",
        align: "center",
        formatter: (cellContent, row) => {
          return (
            <span>
              <Link className="btn btn-sm btn-warning mx-2" to={{ pathname: "/standplaatsen/kampeerplaatsen/monteur/" + row._id }}>
                Instellen meter
              </Link>
            </span>
          );
        },
      },
    ];
    const { kampeerplaatsen } = this.props;

    return (
      <ToolkitProvider
        keyField="_id"
        data={kampeerplaatsen}
        columns={columns}
        search={{
          searchFormatted: true,
        }}
      >
        {(props) => (
          <div>
            <SearchBar placeholder="Zoeken" {...props.searchProps} />
            <hr />
            <BootstrapTable wrapperClasses="table-responsive-md" pagination={paginationFactory({ sizePerPage: 20 })} {...props.baseProps} />
          </div>
        )}
      </ToolkitProvider>
    );
  }
}

export default ElectraWidget;
